interface Props {
  fill?: string;
}

const Workout = ({ fill = '#000' }: Props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
  >
    <path
      fill={fill}
      d="M16.653,4.605 C16.653,4.605 15.754,5.487 15.754,5.487 C17.177,7.031 18.000,9.015 18.000,11.221 C18.000,15.925 14.182,19.674 9.392,19.674 C4.601,19.674 0.783,15.925 0.783,11.221 C0.783,6.663 4.451,2.988 9.017,2.767 C9.017,2.767 9.017,1.297 9.017,1.297 L8.269,1.297 L8.269,0.562 L10.514,0.562 L10.514,1.297 L9.766,1.297 C9.766,1.297 9.766,2.767 9.766,2.767 C11.862,2.840 13.808,3.649 15.230,4.972 C15.230,4.972 16.129,4.090 16.129,4.090 L15.605,3.576 L16.129,3.061 L17.701,4.605 L17.177,5.119 L16.653,4.605 zM9.392,3.502 C5.050,3.502 1.531,6.957 1.531,11.221 C1.531,15.484 5.050,18.939 9.392,18.939 C13.733,18.939 17.252,15.484 17.252,11.221 C17.252,6.957 13.733,3.502 9.392,3.502 zM9.766,12.250 C9.766,12.250 9.766,13.426 9.766,13.426 C9.766,13.646 9.616,13.793 9.392,13.793 C9.167,13.793 9.017,13.646 9.017,13.426 C9.017,13.426 9.017,12.250 9.017,12.250 C8.568,12.103 8.269,11.662 8.269,11.221 C8.269,10.780 8.568,10.339 9.017,10.192 C9.017,10.192 9.017,6.075 9.017,6.075 C9.017,5.854 9.167,5.707 9.392,5.707 C9.616,5.707 9.766,5.854 9.766,6.075 C9.766,6.075 9.766,10.192 9.766,10.192 C10.215,10.339 10.514,10.780 10.514,11.221 C10.514,11.662 10.215,12.103 9.766,12.250 zM9.392,10.853 C9.167,10.853 9.017,11.000 9.017,11.221 C9.017,11.441 9.167,11.588 9.392,11.588 C9.616,11.588 9.766,11.441 9.766,11.221 C9.766,11.000 9.616,10.853 9.392,10.853 z"
    />
  </svg>
);

export default Workout;
